import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ItemNode, ItemNodeWithParent } from '../models/item';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-selected-items-visualizer',
    templateUrl: './selected-items-visualizer.component.html',
    styleUrls: ['./selected-items-visualizer.component.scss'],
    standalone: false
})
export class SelectedItemsVisualizerComponent implements OnChanges {
    itemListHt: any = {};
    itemIds = [];

    @Input() selectedTreeList: ItemNode[] = [];
    @Input() level = 1;

    initItemList(itemList: ItemNode[]) {
        itemList.forEach(item => {
            this.addNodeToHt(item, null);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                const changedProp = changes[propName];
                if (propName === 'itemList' && !changedProp.isFirstChange()) { //  propName === 'itemList' && !changedProp.isFirstChange() // selectedTreeList
                    this.itemIds = [];
                    this.initItemList(changedProp.currentValue);
                }
            }
        }
    }

    private addNodeToHt(item: ItemNode, _parentId: string) {
        this.itemIds.push(item.Id);
        const itemNodeWithParent = new ItemNodeWithParent(item);
        itemNodeWithParent.parentId = _parentId;
        itemNodeWithParent.itemNode.selected = false;
        this.itemListHt[item.Id] = itemNodeWithParent;
        const children = item.children;
        if (children) {
            const parentId = item.Id;
            children.forEach(child => {
                this.addNodeToHt(child, parentId);
            });
        }
    }

    refreshNodeToHt() {
        for (const property in this.itemListHt) {
            this.itemListHt[property].itemNode.selected = false;
        }
    }

    getAllParentIds(nodeId, parents = []) {
        if (this.itemListHt[nodeId].parentId) {
            parents.push(this.itemListHt[nodeId].parentId);
            this.getAllParentIds(this.itemListHt[nodeId].parentId, parents);
        }
        return parents;
    }

    updateValue(_selectedItems: ItemNode[]) {
        this.refreshNodeToHt();
        this.selectedTreeList = [];
        let parentsIds = [];
        if (_selectedItems) {
            _selectedItems.forEach(item => {
                if (this.itemListHt[item.Id]) {
                    this.itemListHt[item.Id].itemNode.selected = true;
                    if (this.itemListHt[item.Id].parentId && !parentsIds.includes(this.itemListHt[item.Id].parentId)) {
                        parentsIds = parentsIds.concat(this.getAllParentIds(item.Id));
                    }
                }
            });
            _selectedItems.forEach(item => {
                item.selected = true;
                if (!parentsIds.includes(item.Id)) {
                    this.setSelectedTreeList(item);
                }
            });
        }
    }

    private setSelectedTreeList(item) {
        const selectedPathList = [];
        this.createSelectedPathList(item.Id, selectedPathList);
        this.insertIntoSelectedTreeList(selectedPathList, this.selectedTreeList);
    }

    private insertIntoSelectedTreeList(selectedPathList, selectedTreeList) {
        const nodeId = selectedPathList.shift();
        selectedTreeList = (selectedTreeList) ? selectedTreeList : [];
        let node = selectedTreeList.find(x => x.Id === nodeId);
        if (!node) { // il nodo non è ancora in lista
            const copyNode = Object.assign({}, this.itemListHt[nodeId]?.itemNode);
            const newNode: ItemNode = new ItemNode(copyNode, true, true);
            if (selectedPathList.length) {
                newNode.children = [];
            }
            selectedTreeList.push(newNode);
            selectedTreeList.sort((a, b) => {
                const indexA = this.itemIds.indexOf(a.Id);
                const indexB = this.itemIds.indexOf(b.Id);
                if (indexA > indexB) {
                    return 1;
                } else if (indexB > indexA) {
                    return -1;
                } else {
                    return 0;
                }
            });
            node = selectedTreeList.find(x => x.Id === newNode.Id);
        }
        if (selectedPathList.length) {
            this.insertIntoSelectedTreeList(selectedPathList, node.children);
        }
    }

    private createSelectedPathList(nodeId: number, pathList) {
        pathList.unshift(nodeId);
        if (this.itemListHt[nodeId] && this.itemListHt[nodeId].parentId) {
            this.createSelectedPathList(this.itemListHt[nodeId].parentId, pathList);
        }
    }
}
